<div class="badge-dot"></div>
